// extracted by mini-css-extract-plugin
export default {"drawer":"add-edit-departments_drawer__tmC1R","footerWrapper":"add-edit-departments_footerWrapper__Oa4yd","footerBackButton":"add-edit-departments_footerBackButton__6O3gd"};